import { render, staticRenderFns } from "./operations-add-or-update.vue?vue&type=template&id=8003f496&scoped=true&"
import script from "./operations-add-or-update.vue?vue&type=script&lang=js&"
export * from "./operations-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./operations-add-or-update.vue?vue&type=style&index=0&id=8003f496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8003f496",
  null
  
)

export default component.exports